import React, { useState, useEffect, useRef } from 'react';
import contactImg2 from "../../assets/images/contact2.png";
import contactImg3 from "../../assets/images/contact3.png";
import contactImg4 from "../../assets/images/contact4.png";

const InquiryQuoteSection = () => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const parallaxRef = useRef(null);

  const rightImages = [contactImg2, contactImg3, contactImg4];

  useEffect(() => {
    let ticking = false;

    const handleScroll = () => {
      if (!ticking) {
        window.requestAnimationFrame(() => {
          if (parallaxRef.current && window.innerWidth >= 1024) {
            const scrolled = window.scrollY;
            parallaxRef.current.style.transform = `translate3d(0, ${scrolled * 0.15}px, 0)`;
          }
          ticking = false;
        });
        ticking = true;
      }
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    handleScroll();

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentImageIndex((prevIndex) => (prevIndex + 1) % rightImages.length);
    }, 4500);
    return () => clearInterval(timer);
  }, [rightImages.length]);

  return (
    <div className="relative mx-auto max-w-[996px] my-6 md:my-12 flex flex-col lg:flex-row items-center justify-center gap-4 px-4">
      <div
        ref={parallaxRef}
        className="w-[220px] sm:w-[260px] md:w-[300px] lg:w-[340px] aspect-[3/4] mx-auto my-4 lg:my-0 lg:absolute lg:-right-[280px] min-[1440px]:-right-[380px] lg:bottom-full lg:-top-[540px] z-10 border-[6px] lg:border-[10px] border-[#f0ece1] rounded-none overflow-hidden shadow-md transition-shadow duration-300 will-change-transform"
      >
        <div className="absolute inset-0 w-full h-full">
          {rightImages.map((imgSrc, idx) => (
            <img
              key={idx}
              src={imgSrc}
              alt={`SeaSalt Creative Studio Portfolio Showcase ${idx + 1}`}
              className={`absolute inset-0 w-full h-full object-cover transition-opacity duration-[1000ms] ${
                idx === currentImageIndex ? 'opacity-100' : 'opacity-0'
              }`}
              loading="lazy"
              decoding="async"
              width="340"
              height="453"
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default InquiryQuoteSection;
